import { render, staticRenderFns } from "./FormMainStreamRecordStreamax.vue?vue&type=template&id=8adc895a&scoped=true&"
import script from "./FormMainStreamRecordStreamax.vue?vue&type=script&lang=ts&"
export * from "./FormMainStreamRecordStreamax.vue?vue&type=script&lang=ts&"
import style0 from "./FormMainStreamRecordStreamax.vue?vue&type=style&index=0&id=8adc895a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8adc895a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('8adc895a', component.options)
    } else {
      api.reload('8adc895a', component.options)
    }
    module.hot.accept("./FormMainStreamRecordStreamax.vue?vue&type=template&id=8adc895a&scoped=true&", function () {
      api.rerender('8adc895a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ConfiguracionCamaras/Streamax/Record/FormMainStreamRecordStreamax.vue"
export default component.exports